import { render, staticRenderFns } from "./baseTree.vue?vue&type=template&id=94c9def2&scoped=true&"
import script from "./baseTree.vue?vue&type=script&lang=js&"
export * from "./baseTree.vue?vue&type=script&lang=js&"
import style0 from "./baseTree.vue?vue&type=style&index=0&id=94c9def2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c9def2",
  null
  
)

export default component.exports